import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hedou-account-layout',
  templateUrl: './account-layout.component.html',
  styleUrls: ['./account-layout.component.less']
})
export class AccountLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
